import { useLocation, matchPath } from 'react-router-dom';
import { ROUTE_SUGGESTIONS_MAP, Suggestion } from '../services/routeSuggestionService';

export const useRouteSuggestions = (): Suggestion[] => {
  const { pathname, search } = useLocation();

  const getDynamicSuggestions = (): Suggestion[] => {
    for (const rule of ROUTE_SUGGESTIONS_MAP) {
      const match = matchPath({ path: rule.pattern, end: rule.exact ?? false }, pathname);
      if (match) {
        return rule.generator(match.params, search, pathname);
      }
    }
    return [];
  };

  return getDynamicSuggestions();
};
